import { toJS } from "mobx";
import * as APITypes from "constants/API";
import axios from "axios";

import getCookie from "utils/journeyIdCookie/getJourneyId";
import AuthStore from "../../../../../src/modules/login/store/AuthStore";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
import OptimizationStore from "../../../optimization/store/OptimizationStore";
const getRecommendedProductData = async () => {
    let productDetails = JSON.parse(localStorage.getItem('recommendedProduct'))
    await AuthStore.fetchJourneyData()
    const journeyData = toJS(AuthStore.journeyData)
    const familyProductDetails = journeyData.family_product_details_list.filter((item) => item.id === productDetails.family_product_id)[0]
    const lifeAssuredDetails = journeyData.family_details_list.filter((item) => item.id === familyProductDetails.family)
    const proposerDetails = journeyData.family_details_list.filter((item) => item.id === familyProductDetails.proposer_family)

    //! request for GET_RECOMMENDATION_RISK_DETAILS 
    let requestObj = {
        journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        family_product_id: productDetails.family_product_id,
        risk_type: productDetails.risk
    }

    //! request for FETCH_CHANGE_PRODUCT_LIST 
    let productRequestObj = {
        family_product_id: productDetails.family_product_id,
        risk: productDetails.risk,
        target_amount: 0,
        recommended_cover: productDetails.recommended_cover,
        current_product_id: productDetails.current_product_id,
        current_package_id: productDetails.current_package_id,
        user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
    }

    //! for get recommendaed product data 
    let productResponse = await axios.post(APITypes.GET_RECOMMENDATION_RISK_DETAILS, requestObj)

    //! for get product list
    let productlist = await axios.post(APITypes.FETCH_CHANGE_PRODUCT_LIST, productRequestObj)

    //! format data
    let productDetailsStructure = {}
    if (productResponse.data[0].need_title === "Protection for my Family") {

        let jsonOutputData = JSON.parse(productResponse.data[0].data[0].BI.JsonOutput);
        let biData2 = [];
        if (jsonOutputData && jsonOutputData.hasOwnProperty("BIJson2") && jsonOutputData?.BIJson2
        ) {
            biData2 = JSON.parse(jsonOutputData.BIJson2);
        } else {
            biData2 = JSON.parse(jsonOutputData.BIJson);
        }

        let newproductlist = productlist?.data.filter(
            (resultData) => resultData.package_id !== productDetails.current_package_id
        );

        productDetailsStructure = {
            tab: productResponse.data[0].data[0].selected_risk_type,
            selectedTab: productResponse.data[0].data[0].selected_risk_type,
            cardKey: productResponse.data[0].need_unique_name,
            productName: productResponse.data[0].data[0].product_name,
            data: {
                risk: productResponse.data[0].data[0].selected_risk_type,
                BI: {},
                bi_request: productResponse.data[0].data[0].bi_request,
                update_BI: true,
                firstYearResponse: biData2[0],
                parsedResponse: biData2[biData2.length - 1],
                biResponseCompleteData: biData2,
                isErrorExist: false,
                errorMessage: "",
                totalPrice: "-",
                quotationId: jsonOutputData?.QuotationId,
                isValidationExist: false,
                changeProductList: newproductlist,
                fieldChanged: false,
                maximum_sum_assured: productResponse.data[0].data[0].maximum_sum_assured,
                minimum_sum_assured: productResponse.data[0].data[0].minimum_sum_assured,
                package_id: productResponse.data[0].data[0].package_id,
                product_id: productResponse.data[0].data[0].product_id,
                product_name: productResponse.data[0].data[0].product_name,
                recommended_sum_assured: productResponse.data[0].data[0].recommended_sum_assured,
                selected_sum_Assured: productResponse.data[0].data[0].selected_sum_Assured,
                target_sa_more_than_reco_sa: productResponse.data[0].data[0].target_sa_more_than_reco_sa,
                family_product_id: productResponse.data[0].data[0].family_product_id,
                nudge_message: productResponse.data[0].data[0].nudge_message,
                dob: lifeAssuredDetails[0].dob,
                family_member_type: lifeAssuredDetails[0].family_member_type,
                gender: lifeAssuredDetails[0].gender,
                income_type: lifeAssuredDetails[0].income_type,
                id: productResponse.data[0].data[0].id,
                isSelected: true,
                monthly_income: lifeAssuredDetails[0].monthly_income,
                payout_mode: familyProductDetails?.payout_mode,
                life_assured_details: lifeAssuredDetails,
                proposer_details: proposerDetails,
                selectedRisk: productResponse.data[0].data[0].selected_risk_type,
                selected_risk_type: productResponse.data[0].data[0].selected_risk_type,
                isDisabledNeed: false,
                productDisabled: false,
                selectedPrice: "-"
            },
            showModalBackDrop: false,
            disabled: false,
        }
    } else {
        
        let jsonOutputData = JSON.parse(productResponse.data[0].data[0].BI[0].BI.JsonOutput);
        let biData2 = [];
        if (jsonOutputData && jsonOutputData.hasOwnProperty("BIJson2") && jsonOutputData?.BIJson2
        ) {
            biData2 = JSON.parse(jsonOutputData.BIJson2);
        } else {
            biData2 = JSON.parse(jsonOutputData.BIJson);
        }

        let newproductlist = productlist?.data.filter(
            (resultData) => resultData.package_id !== productDetails.current_package_id
        );

        productDetailsStructure = {
            tab: productResponse.data[0].data[0].selected_risk_type,
            selectedTab: productResponse.data[0].data[0].selected_risk_type,
            cardKey: productResponse.data[0].need_unique_name,
            productName: productResponse.data[0].data[0].BI[0].product_name,
            data: {
                risk: productResponse.data[0].data[0].selected_risk_type,
                BI: [],
                bi_request: productResponse.data[0].data[0].BI[0].bi_request,
                update_BI: true,
                firstYearResponse: biData2[0],
                parsedResponse: biData2[biData2.length - 1],
                biResponseCompleteData: biData2,
                isErrorExist: false,
                errorMessage: "",
                totalPrice: "-",
                quotationId: jsonOutputData?.QuotationId,
                isValidationExist: false,
                changeProductList: newproductlist,
                fieldChanged: false,
                maximum_sum_assured: productResponse.data[0].data[0].BI[0].maximum_sum_assured,
                minimum_sum_assured: productResponse.data[0].data[0].BI[0].minimum_sum_assured,
                package_id: productResponse.data[0].data[0].BI[0].package_id,
                product_id: productResponse.data[0].data[0].BI[0].product_id,
                product_name: productResponse.data[0].data[0].BI[0].product_name,
                recommended_sum_assured: productResponse.data[0].data[0].BI[0].recommended_sum_assured,
                selected_sum_Assured: productResponse.data[0].data[0].BI[0].selected_sum_Assured,
                target_sa_more_than_reco_sa: productResponse.data[0].data[0].BI[0].target_sa_more_than_reco_sa,
                family_product_id: productResponse.data[0].data[0].BI[0].family_product_id,
                nudge_message: productResponse.data[0].data[0].BI[0].nudge_message,
                dob: lifeAssuredDetails[0].dob,
                family_member_type: lifeAssuredDetails[0].family_member_type,
                gender: lifeAssuredDetails[0].gender,
                income_type: lifeAssuredDetails[0].income_type,
                id: productResponse.data[0].data[0].id,
                isSelected: true,
                monthly_income: lifeAssuredDetails[0].monthly_income,
                payout_mode: familyProductDetails?.payout_mode,
                life_assured_details: lifeAssuredDetails,
                proposer_details: proposerDetails,
                selectedRisk: productResponse.data[0].data[0].selected_risk_type,
                selected_risk_type: productResponse.data[0].data[0].selected_risk_type,
                isDisabledNeed: false,
                productDisabled: false,
                selectedPrice: "-"
            },
            showModalBackDrop: false,
            disabled: false,
        }

    }

    //! set Recommended Product Data
    OptimizationStore.setRecommendedProductData(productDetailsStructure)

}
export default getRecommendedProductData